import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import { Line } from "react-chartjs-2";
import { IoReloadCircle } from "react-icons/io5";
import { Link } from "react-router-dom";
import {
  FaBuildingShield,
  FaMoneyBillTrendUp,
  FaUserGroup,
} from "react-icons/fa6";
import { CiEdit } from "react-icons/ci";
import { CgPlayTrackNextO } from "react-icons/cg";
import {
  MdAirplanemodeInactive,
  MdDisabledVisible,
  MdEditDocument,
  MdNavigateNext,
  MdNotificationsActive,
} from "react-icons/md";
import { Button } from "react-bootstrap";
import { Addfirmsmodal, Editmodal } from "./Modal";
import { FaBellSlash, FaBuilding } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import swal from "sweetalert";
import { twoDecimalPlaces } from "../../utils/utilFuctions";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
const Superadmindashboard = () => {
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const [Firms, setFirms] = useState([]);
  const [activeFirms, setActiveFirms] = useState(0);
  const [inactiveFirms, setInactiveFirms] = useState(0);
  const [totalFirms, setTotalFirms] = useState(0);
  const [firmType, setFirmType] = useState(0);
  const [Showfirms, setShowfirms] = useState(false);
  const [editmodal, seteditmodal] = useState(false);
  const [selectedFirm, setSelectedFirm] = useState(null);

  const Openeditmodal = (firmData) => {
    setSelectedFirm(firmData);
    seteditmodal(true);
  };

  const Closeeditmodal = () => {
    seteditmodal(false);
  };
 
  const openfirmsmodal = () => {
    setShowfirms(true);
  };

  const closefirmsmodal = () => {
    setShowfirms(false);
  };
  const Getfirms = async () => {
    setTransactionLoaderState(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({});

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAllFirmsSuperAdmin`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setFirms(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getfirmdash = async () => {
    setTransactionLoaderState(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({});

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetSuperAdminDashboard`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        const dashboardData = data.data[0];
        setActiveFirms(dashboardData.active_firms);
        setInactiveFirms(dashboardData.inactive_firms);
        setTotalFirms(dashboardData.total_firms);
        setFirmType(dashboardData.firmtype);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };


 
  const [desable, setdesable] = useState("");
  const Firmdisable = async (pk_firmid) => {
    // Show confirmation dialog
    swal({
      title: "Are you sure?",
      text: "Once disabled, you will not be able to recover this Firm!",
      icon: "warning",
      buttons: ["Cancel", "Yes"],
      dangerMode: true,
    })
      .then((confirmed) => {
        if (confirmed) {
          // User confirmed, proceed with API call
          setTransactionLoaderState(true);
          try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
              firmid: pk_firmid,
            });

            var requestOptions = {
              method: "POST",
              headers: myHeaders,
              body: raw,
              redirect: "follow",
            };

            return fetch(
              `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/DisableFirmsSuperAdmin`,
              requestOptions
            );
          } catch (error) {
            console.log("error", error);
            swal(
              "Error",
              "An error occurred while disabling the employee.",
              "error"
            );
          } finally {
            setTransactionLoaderState(false);
          }
        } else {
          // User cancelled, do nothing
        }
      })
      .then(async (res) => {
        if (res) {
          const data = await res.json();
          if (data.status === "0") {
            setdesable(data.data);
            swal("Success", data.result, "success");
            Getfirms();
          } else {
            swal("Success", data.result, "success");
            Getfirms();
          }
        }
      })
      .catch((error) => {
        console.log("error", error);
        swal(
          "Error",
          "An error occurred while disabling the employee.",
          "error"
        );
      });
  };
 

  useEffect(() => {
    Getfirms();
    Getfirmdash();
  }, []);

  return (
    <>
      <Addfirmsmodal
        show={Showfirms}
        closeModal={closefirmsmodal}
        Getfirms={Getfirms}
      />
      <div className="mt-4 m-2">
        <h4>Welcome to Super Admin Dashboard!</h4>
    
        <div className="row">
  {/* Active */}
  <div className="col-md-3 p-1">
    <div className="card p-2 bg-warning">
      <div className="row m-0 p-0">
        <div className="col-8 m-0 p-0">
          <MdNotificationsActive style={{ color: "#fff", fontSize: "2.5rem" }} />
          <h5 style={{ color: "#fff" }}>Active</h5>
        </div>
        <div className="col-4 m-0 p-0 d-flex justify-content-center align-items-center">
          <h4 style={{ color: "#fff" }}>{activeFirms}</h4>
        </div>
      </div>
    </div>
  </div>

  {/* Inactive */}
  <div className="col-md-3 p-1">
    <div className="card p-2 bg-danger">
      <div className="row m-0 p-0">
        <div className="col-8 m-0 p-0">
          <FaBellSlash style={{ color: "#fff", fontSize: "2.5rem" }} />
          <h5 style={{ color: "#fff" }}>In-Active</h5>
        </div>
        <div className="col-4 m-0 p-0 d-flex justify-content-center align-items-center">
          <h4 style={{ color: "#fff" }}>{inactiveFirms}</h4>
        </div>
      </div>
    </div>
  </div>

  {/* Total Firms */}
  <div className="col-md-3 p-1">
    <div className="card p-2 bg-secondary">
      <div className="row m-0 p-0">
        <div className="col-8 m-0 p-0">
          <FaBuildingShield style={{ color: "#fff", fontSize: "2.5rem" }} />
          <h5 style={{ color: "#fff" }}>Total Firms</h5>
        </div>
        <div className="col-4 m-0 p-0 d-flex justify-content-center align-items-center">
          <h4 style={{ color: "#fff" }}>{totalFirms}</h4>
        </div>
      </div>
    </div>
  </div>

  {/* Firm Type */}
  <div className="col-md-3 p-1">
    <div className="card p-2 bg-info">
      <div className="row m-0 p-0">
        <div className="col-8 m-0 p-0">
          <FaBuilding style={{ color: "#fff", fontSize: "2.5rem" }} />
          <h5 style={{ color: "#fff" }}>Firm Type</h5>
        </div>
        <div className="col-4 m-0 p-0 d-flex justify-content-center align-items-center">
          <h4 style={{ color: "#fff" }}>{firmType}</h4>
        </div>
      </div>
    </div>
  </div>
</div>
        <div className="row">
          <h5 className="col">Manage Firms</h5>
          <div className="col d-flex justify-content-end">
            <Button
              onClick={openfirmsmodal}
              style={{ background: "#481E14" }}
              className="btn-sm"
            >
              Add Firms
            </Button>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 1,
                background: "#fff",
              }}
            >
              <tr>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#E1F7F5",
                  }}
                >
                  Firm Name
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#E1F7F5",
                  }}
                >
                  Owner
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#E1F7F5",
                  }}
                >
                  Firm Type / GST
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#E1F7F5",
                  }}
                >
                  Address
                </th>

                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#E1F7F5",
                  }}
                >
                  Contact
                </th>

                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#E1F7F5",
                  }}
                >
                  Status
                </th>

                <th
                  style={{
                    borderBottom: "1px solid #f2f4f2",
                    color: "#000",
                    padding: "8px",
                    textAlign: "left",
                    background: "#E1F7F5",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {Firms.map((item) => (
                <React.Fragment key={item.pk_firm_id}>
                  <tr style={{ border: "none", cursor: "pointer" }}>
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        fontWeight: "600",
                      }}
                    >
                      {item.firm_name}
                    </td>

                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        fontWeight: "600",
                      }}
                    >
                      {item.firm_owner_name}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        fontWeight: "600",
                      }}
                    >
                      {item.firm_type}
                      <br />
                      {item.firm_gst}
                    </td>

                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        fontWeight: "600",
                      }}
                    >
                      {item.firm_address}
                    </td>

                    <td
                      style={{
                        padding: "8px",
                        textAlign: "left",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        fontWeight: "600",
                      }}
                    >
                      {item.firm_email}
                      <br /> {item.firm_mobile}
                    </td>
                    <td className="d-flex "
                      style={{
                        padding: "8px",
                        textAlign: "center",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        fontWeight: "600",
                        alignItems:"center"
                      }}
                    >
                      {item.firm_status === "N" && (
                        <span
                          className=" p-1 "
                          style={{
                            backgroundColor: "rgba(255, 46, 46, 0.1)",
                            color: "#ff2e2e",
                            border: "1px solid #ff2e2e",
                            borderRadius: ".3rem",fontSize:".7rem"
                          }}
                        >
                          InActive
                        </span>
                      )}
                      {item.firm_status === "Y" && (
                        <span
                          className=" p-1 "
                          style={{
                            backgroundColor: "rgba(43, 193, 85, 0.1)",
                            color: "#2bc155",
                            border: "1px solid #2bc155",
                            borderRadius: ".3rem",fontSize:".7rem"
                          }}
                        >
                          Active
                        </span>
                      )}{" "}
                     
                    
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        // textAlign: "ce",
                        border: "none",
                        fontSize: ".8rem",
                        borderBottom: "1px solid #f2f4f2",
                        borderRight: "1px solid #f2f4f2",
                        fontWeight: "600",
                      }}
                    >
                      <CiEdit
                        onClick={() => Openeditmodal(item)}
                        style={{ fontSize: "1.5rem", color: "#000" }}
                      />
                      <MdDisabledVisible
                        onClick={() => Firmdisable(item.pk_firmid)}
                        style={{ fontSize: "1.2rem", color: "#000" }}
                      />
                      <Link to="/superadmin/firm-dashboard">
                        <MdNavigateNext
                          onClick={() => {
                            sessionStorage.setItem(
                              "Firms",
                              JSON.stringify(item)
                            );
                          }}
                          style={{ fontSize: "1.2rem", color: "#000" }}
                        />
                      </Link>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>

        <Editmodal
          show={editmodal}
          closeModal={Closeeditmodal}
          Getfirms={Getfirms}
          selectedFirm={selectedFirm}
        />
      </div>
    </>
  );
};
export default Superadmindashboard;
